import {getSaleHistoryByApi, getSaleHistorySearchByApi} from '@web/actions/saleHistory'
import {PaginationState} from '@web/slices/pagination/slice'
import makeSlice from '@web/slices/pagination/sliceMaker'

const initializePagination = (state: PaginationState) => {
    state.current = 0
    state.start = 0
    state.end = 0
    state.total = 0
    state.infinite = {
        apiStatus: 'IDLE',
    }
}

const paginationSlice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(getSaleHistoryByApi.pending, (state) => {
                state.type = 'WIDE'
            })
            .addCase(getSaleHistoryByApi.fulfilled, (state, {payload}) => {
                const {curPage, totalPage} = payload

                initializePagination(state)

                state.current = curPage
                state.start = 1
                state.end = totalPage
                state.total = totalPage
            })
            .addCase(getSaleHistorySearchByApi.pending, (state) => {
                state.type = 'INFINITE'
                state.infinite.apiStatus = 'FETCHING'
            })
            .addCase(getSaleHistorySearchByApi.fulfilled, (state, {payload}) => {
                initializePagination(state)

                const {nextCursor} = payload
                state.infinite = {
                    nextCursor,
                    apiStatus: 'RESOLVED',
                }
            })
            .addCase(getSaleHistorySearchByApi.rejected, (state) => {
                state.infinite.apiStatus = 'REJECTED'
            })
    },
})

export default paginationSlice.reducer
